import marked from 'marked';
import React, { useEffect } from 'react';

import { Container } from './ForecasterGuidance.style';
import { IWidgetBlockComponent } from '../types/IWidgetBlock';
import { ForecasterGuidanceModel } from './types';

const ForecasterGuidance: React.FC<IWidgetBlockComponent<ForecasterGuidanceModel>> = (props) => {
    const widgetModel = props.widgetModel;
    useEffect(() => {
        marked.setOptions({
            renderer: new marked.Renderer(),
            gfm: true,
            tables: true,
            breaks: true,
            pedantic: false,
            sanitize: false,
            smartLists: true,
            smartypants: true,
        });
    }, []);

    if (!widgetModel) {
        return null;
    }

    const { fontSize, content } = widgetModel;
    const hasContent = !!content;

    return (
        <Container className='forecasterGuidanceRender' fontSize={`${fontSize || 100}%`}>
            {hasContent && React.createElement('div', { dangerouslySetInnerHTML: { __html: marked(content) } })}
            {!hasContent && React.createElement('div', {}, 'A forecaster feed has not been setup for this viewblock')}
        </Container>
    );
};

export default ForecasterGuidance;
